var _path, _line, _line2, _path2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.642 24.2565C22.098 23.9449 22.215 23.3227 21.9034 22.8667C21.5919 22.4107 20.9696 22.2936 20.5136 22.6052L21.642 24.2565ZM15.5699 24.9897L15.6177 23.9908L15.5699 24.9897ZM10.236 22.9119L9.59556 23.6799L10.236 22.9119ZM11.6484 8.12204L11.1649 7.24672L11.1649 7.24672L11.6484 8.12204ZM17.2791 7.09131L17.4212 6.10146L17.2791 7.09131ZM22.3924 9.66442L21.6822 10.3684L21.6822 10.3684L22.3924 9.66442ZM23.9288 14.9337C24.0024 15.4811 24.5058 15.8652 25.0532 15.7915C25.6005 15.7179 25.9846 15.2145 25.911 14.6672L23.9288 14.9337ZM20.5136 22.6052C19.0759 23.5876 17.357 24.0741 15.6177 23.9908L15.5221 25.9885C17.6962 26.0926 19.8449 25.4845 21.642 24.2565L20.5136 22.6052ZM15.6177 23.9908C13.8784 23.9076 12.2138 23.2591 10.8765 22.1439L9.59556 23.6799C11.2672 25.0739 13.348 25.8845 15.5221 25.9885L15.6177 23.9908ZM10.8765 22.1439C9.5392 21.0287 8.6023 19.5076 8.20799 17.8116L6.25995 18.2644C6.75283 20.3845 7.92396 22.2859 9.59556 23.6799L10.8765 22.1439ZM8.20799 17.8116C7.81369 16.1155 7.98351 14.3371 8.69169 12.7464L6.86457 11.933C5.97935 13.9214 5.76706 16.1444 6.25995 18.2644L8.20799 17.8116ZM8.69169 12.7464C9.39987 11.1556 10.6077 9.83933 12.1319 8.99737L11.1649 7.24672C9.25962 8.29917 7.7498 9.94451 6.86457 11.933L8.69169 12.7464ZM12.1319 8.99737C13.6561 8.15541 15.4134 7.83373 17.137 8.08116L17.4212 6.10146C15.2667 5.79216 13.0701 6.19426 11.1649 7.24672L12.1319 8.99737ZM17.137 8.08116C18.8606 8.32859 20.4564 9.13163 21.6822 10.3684L23.1027 8.96047C21.5704 7.41454 19.5757 6.41075 17.4212 6.10146L17.137 8.08116ZM21.6822 10.3684C22.9079 11.6051 23.6967 13.208 23.9288 14.9337L25.911 14.6672C25.6209 12.51 24.6349 10.5064 23.1027 8.96047L21.6822 10.3684Z",
    fill: "#2A84FF"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: 12,
    x2: 16,
    y2: 20,
    stroke: "#83DBFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 16,
    x2: 20,
    y2: 16,
    stroke: "#83DBFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 26.3203L23.9896 28.2112C24.5101 28.8719 25.5091 28.8793 26.0394 28.2264L27.5875 26.3203",
    stroke: "#1AB6FF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    opacity: 0.9,
    x1: 1,
    y1: -1,
    x2: 8,
    y2: -1,
    transform: "matrix(0 -1 -1 0 24.1212 25.8333)",
    stroke: "#83DBFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceive);
export default __webpack_public_path__ + "static/media/Receive.b38dbeb32002054ab1c59ce231f654a6.svg";
export { ForwardRef as ReactComponent };